import React, { useContext } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { FormLabel, Switch, TextField } from '@mui/material';
import axios from "axios"
import { Box } from '@mui/system';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { AuthContext } from '../authContext/AuthContext';
import LoginError from './LoginError';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AddUser = ({addDialog, handleClose}) => {
    const [username,setUsername] = React.useState("");
    const [password,setPassword] = React.useState("");
    const [email,setEmail] = React.useState("");
    const [name,setName] = React.useState("");
    const [phone,setPhone] = React.useState("");
    const [isAdmin,setIsAdmin] = React.useState(false);
    const [shops, setShops] = React.useState([]);
    const [disabled, setDisabled] = React.useState(false);
    const [usernameError, setUsernameError] = React.useState(false)
    const [emailError, setEmailError] = React.useState(false)
    const {user} = useContext(AuthContext)

    const resetField = async() => {
      setUsername("")
      setPassword("")
      setEmail("")
      setName("")
      setPhone("")
      setIsAdmin(false)
      setDisabled(false)
      setUsernameError(false)
      setEmailError(false)
      getShops(user)
    }

    const handleCloseDialog = async() => {
      handleClose();
      resetField();
    };
    const getShops = async(user) => {
      try {
        const res = await axios.get("/shops", {headers: {token:"Bearer " + user.token}})
        const checkedShops = [];
        res.data.map(shop => {
          checkedShops.push({ ...shop, checked: false})
          return shop
        });
        setShops(checkedShops)
      } catch (err) {
        console.log(err)
      }
    };
    React.useEffect(() => {
      getShops(user);
    },[user]);

    React.useEffect(() => {
      const validate = async() => {
        setDisabled(username.trim().length === 0
        || email.trim().length === 0 
        || phone.trim().length === 0 
        || password.trim().length === 0)
      };
      validate();
    },[username, email, password, phone]);

    const addUser = async() => {
      try {
        const res = await axios.get("/users/countUsername/" + username, {headers: {token:"Bearer " + user.token}})
        if(res.data > 0) {
           setUsernameError(true)
           return
        } else {
          setUsernameError(false)
        }
        const res1 = await axios.get("/users/countEmail/" + email, {headers: {token:"Bearer " + user.token}})
        if(res1.data > 0) {
          setEmailError(true)
           return
        } else {
          setEmailError(false)
        }
        const checkedShops = [];
        shops.map(shop => {
          if (shop.checked) {
            const { checked, ...otherDetails } = shop;
            checkedShops.push(otherDetails)
          }
          return shop
        });
        const createUser = {username, email, password, name, phone, isAdmin, allowedShops: checkedShops}
        await axios.post("/auth/register", createUser, {headers: {token:"Bearer " + user.token}})
        handleClose();
        resetField();
      } catch (err) {
        console.log(err)
      }
    };

    const handleChange = (createdShop) => {
      const checkedShops = [];
      shops.map(shop => {
        if (shop.shopkey === createdShop.shopkey) {
          checkedShops.push({...shop, checked: !shop.checked})
        } else {
          checkedShops.push(shop)
        }
        return shop
      });
      setShops(checkedShops)
    }
  return (
    <div>
      <Dialog
        open={addDialog}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        sx={{width: "100vw"}}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Add User
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="User Name" variant="standard" fullWidth value={username} onChange={(event)=> setUsername(event.target.value)}/></Grid>
            <LoginError error={usernameError} errorMessage="Username exists" />
            <Grid item xs={12}><TextField type='password' label="Password" variant="standard" fullWidth value={password} onChange={(event)=> setPassword(event.target.value)}/></Grid>
            <Grid item xs={12}><TextField label="Email" variant="standard" fullWidth value={email} onChange={(event)=> setEmail(event.target.value)}/></Grid>
            <LoginError error={emailError} errorMessage="Email exists" />
            <Grid item xs={12}><TextField label="Display Name" variant="standard" fullWidth value={name} onChange={(event)=> setName(event.target.value)}/></Grid>
            <Grid item xs={12}><TextField label="Phone" variant="standard" fullWidth value={phone} onChange={(event)=> setPhone(event.target.value)}/></Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel control={<Switch checked={isAdmin} onChange={()=> setIsAdmin(!isAdmin)}/>} label="Admin" />
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <FormLabel component="legend">Allowed Shops</FormLabel>
              <FormGroup>
                {shops.map((shop) => (
                  <FormControlLabel key={shop.shopkey} control={<Checkbox name={shop.shopkey} checked={shop.checked} onChange={() => handleChange(shop)}/>} label={shop.shopname}/>
                ))}
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <Button autoFocus variant="contained" onClick={addUser} disabled={disabled} fullWidth>
              Save
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default AddUser
